/**
 * Faixa do topo com mensagens rolando (frete grátis, promoção, parcelamento).
 * Mostra uma mensagem por vez, troca a cada 4 s, pausa com o mouse em cima ou foco no teclado
 * e ignora mensagens vencidas (data-expires). Com uma única mensagem não faz nada.
 */
(() => {
  const INTERVAL = 4000;

  document.querySelectorAll('[data-bar-rotator]').forEach((bar) => {
    const messages = [...bar.querySelectorAll('.header-free-shipping-bar__msg')].filter((message) => {
      const expires = message.dataset.expires;
      if (expires && Date.parse(expires) < Date.now()) {
        message.hidden = true;
        return false;
      }
      return true;
    });
    if (messages.length < 2) return;

    let index = 0;
    let timer = null;

    const show = (next) => {
      messages[index].classList.remove('is-active');
      index = next;
      messages[index].classList.add('is-active');
    };
    const start = () => {
      stop();
      timer = setInterval(() => show((index + 1) % messages.length), INTERVAL);
    };
    const stop = () => clearInterval(timer);

    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    bar.addEventListener('focusin', stop);
    bar.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
    start();
  });
})();
